import {Space} from "antd";
import {CustomerOrderListHeader} from "./list/header";
import {CustomerServiceOrderList} from "./list";

export function CustomerServiceOrders() {
  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <CustomerOrderListHeader />
      <CustomerServiceOrderList />
    </Space>
  );
}
